var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 50,
    viewBox: "0 0 89 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 50,
    rx: 5,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 34L15 25L25 16",
    stroke: "#424242",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8867 34.3906H49.5234V15.0117H51.8867V34.3906ZM35.9023 25.4102C38.5521 25.403 40.833 25.3743 42.7451 25.3242C44.6572 25.2669 46.5156 25.138 48.3203 24.9375L48.4277 26.6992C46.8307 26.9355 45.1048 27.1074 43.25 27.2148V33.8105H40.8652V27.3223C39.4544 27.3652 37.7858 27.3867 35.8594 27.3867L35.5801 25.4102H35.9023ZM37.3418 16.0645H46.7734V17.9551H39.7266V21.3281H47.0098V23.2617H37.3418V16.0645ZM72.8443 32.1562H55.0982V30.1797H62.7466V27.0215H57.2037V20.6621H68.3755V18.2559H57.1607V16.3223H70.7388V22.5527H59.5884V25.0664H71.19V27.0215H65.1099V30.1797H72.8443V32.1562Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.b8e8eb76788940d54bada9a2118f343c.svg";
export { ForwardRef as ReactComponent };